import { render, staticRenderFns } from "./PatientCountChart.vue?vue&type=template&id=9b79bc4c"
import script from "./PatientCountChart.vue?vue&type=script&lang=js"
export * from "./PatientCountChart.vue?vue&type=script&lang=js"
import style0 from "./PatientCountChart.vue?vue&type=style&index=0&id=9b79bc4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports